/*
 * ClubControls Messages
 *
 * This contains all the text for the ClubControls component.
 */

import { defineMessages } from 'react-intl';

export default defineMessages({
  showLocations: {
    id: 'app.components.ClubControls.showLocations',
    defaultMessage: 'Show clubs',
  },
  nameOrCity: {
    id: 'app.components.ClubControls.nameOrCity',
    defaultMessage: 'Name or city',
  },
  reset: {
    id: 'app.components.ClubControls.reset',
    defaultMessage: 'Reset filter',
  },
});
